module.exports = __webpack_public_path__ + "static/pillow-design-process-ba3b588d7bcda4c708c998cf7d76a053.mp4";